import React from 'react';

import { Box, BoxProps } from '@mantine/core';
import { SmartAssistantVisualConfig } from 'shared/interfaces/SmartAssistant';
import { buildSmartAssistantLinearGradientStyle } from 'shared/utils/smart-assistant';

interface ChatGradientProps extends BoxProps {
  smartAssistantVisualConfig: SmartAssistantVisualConfig;
}

export function ChatGradient({ smartAssistantVisualConfig, ...boxProps }: ChatGradientProps) {
  const gradientColors = smartAssistantVisualConfig.gradientColors;

  return (
    <Box
      sx={{
        position: 'absolute',
        width: '100%',
        height: '20%',
        ...buildSmartAssistantLinearGradientStyle(gradientColors),
        bottom: 0,
        zIndex: 0,
        pointerEvents: 'none'
      }}
      {...boxProps}
    />
  );
}
